export const API_DELETE_PROFILE_URL = process.env.API_GET_PROFILES_URL || 'delete_profile.aspx'
export const API_GET_PROFILES_URL = process.env.API_GET_PROFILES_URL || 'get_profiles.aspx'
export const API_SAVE_PROFILE_URL = process.env.API_SAVE_PROFILE_URL || 'save_profile.aspx'
